<template>
    <div class="patent-view compare-view">
        <div v-if="!isOverFreeViewLimit" :class="['patent-app', 'draggable-panel-bounce', { 'show-patent-list': isShowPatentList, 'no-patent-list': isFree }]">
            <!--main-body-->
            <div class="patent-app__main">
                <!--router-view-->
                <div :class="{ [CLASS_NAME_APP_CONTENT]: true, ['dual-view']: isDualView,}" flex>
                    <!--视图入口-->
                    <main :class="{ ...classNames, 'flex-full-stretch': true }" flex="-">
                        <template v-if="leftPatentId">
                            <!--left入口-->
                            <router-view
                                :key="`${leftPatentId}-left`"
                                ref="viewLeft"
                                :patentId="leftPatentId"
                                :neighborName="viewParams.neighborhoodsNames.right"
                                :viewParams="viewParams"
                                :selfName="viewParams.neighborhoodsNames.left"
                                class="view-left"
                                name="compareLeft"
                                neighborSide="right"
                                side="left"
                            />
                        </template>
                        <template v-if="rightPatentId">
                            <!--right入口-->
                            <!--这里放一个假的专利loading页面-->
                            <ComparePatentLoading v-if="rightPatentId === 'default'" side="right" />
                            <router-view
                                v-else
                                :key="`${rightPatentId}-right`"
                                ref="viewRight"
                                :patentId="rightPatentId"
                                :neighborName="viewParams.neighborhoodsNames.left"
                                :viewParams="viewParams"
                                :selfName="viewParams.neighborhoodsNames.right"
                                class="view-right"
                                name="compareRight"
                                neighborSide="left"
                                side="right"
                            />
                        </template>
                    </main>
                    <!--right-bar-->
                    <SideFunctionBarCompare
                        v-if="!isFree"
                        :isCollapsed="!isShowPatentList"
                        :patentId="[leftPatentId === 'default' ? '' : leftPatentId, rightPatentId === 'default' ? '' : rightPatentId]"
                        :viewParams="viewParams"
                        class="patent-app__right-column"
                    />
                </div>
            </div>
            <!--dialog容器-->
            <div id="float-pannel-mount-point" />
        </div>
        <!--无权限页面-->
        <PermissionTips v-else />
        <!--Toast-->
        <snap-alert
            :type="alertType"
            :visible="alertVisible"
            :message="alertMessage"
            :onClose="alertOnClose"
            :autoClose="true"
        />
    </div>
</template>

<script>
import { AlertMixin } from 'library-@/mixins';
import SnapAlert from 'library-@/components/snap-ui/alert-v2';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { installHighlightStyle, CLASS_NAME_CHEMICAL_HIGHLIGHT_SCROLL_DOM } from '@patsnap-utils/highlight';
import PermissionTips from '@/components/no-permission/PermissionTips';
import { bindHotKeys, unBindHotKeys } from '../../utils/hotKeys';
import defer from '../../utils/defer';
import SideFunctionBarCompare from '../side-function-bar/SideFunctionBar_Compare';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import addIframe from '../../directives/addIframe';
import {
    NAMESPACE_PATENT_VIEW,
    CLASS_NAME_APP_CONTENT,
    CLASS_NAME_SHOW_SEQUENCE,
    CLASS_NAME_HIDE_SEQUENCE,
    CLASS_NAME_HIDE_STRUCTURE,
    CLASS_NAME_HIDE_OTHERS_STRUCTURE,
} from '@/constants';
import bioHlbtnVisibleMixin from '@/mixins/bio-hlbtn-visible';
import { getRouteNameList } from '../../router';
import ComparePatentLoading from '@/components/compare-components/compare-patent-loading/ComparePatentLoading.vue';
import { setGlobalRvTrackAttr } from '@/utils/rvTrack';
import { useCompareUrlState, ERouterMode } from '@/composables/use-compare-url-state';
import { usePatentsList } from '@/views/side-function-bar/patents-list/composables/use-patents-list';
import { useFreeViewLimit } from '@/components/no-permission/composables/use-free-view-limit';
import { usePatentBasic } from '@/composables/use-patent-basic';

export default {
    name: 'CompareRoot',
    components: {
        SnapAlert,
        PermissionTips,
        SideFunctionBarCompare,
        ComparePatentLoading,
    },
    directives: {
        addIframe,
    },
    mixins: [
        AlertMixin,
        bioHlbtnVisibleMixin,
    ],
    props: {
        viewParams: Object,
    },
    setup() {
        const {
            isSourcePatent,
            isSourceEditPatent,
            isSourceEditText,
            isSourceCustomText,
            changeCompareMode,
        } = useCompareUrlState();

        const {
            isShowPatentList,
            setPatentListVisible,
        } = usePatentsList();

        const {
            isOverFreeViewLimit,
            setIsOverFreeView,
        } = useFreeViewLimit();

        const {
            getPatentBase,
        } = usePatentBasic();

        return {
            isSourcePatent,
            isSourceEditPatent,
            isSourceEditText,
            isSourceCustomText,
            changeCompareMode,
            isShowPatentList,
            setPatentListVisible,
            isOverFreeViewLimit,
            setIsOverFreeView,
            getPatentBase,
        };
    },
    data() {
        return {
            isFree: getIsFreeView(),
            isSpecialIp: _.get(window, 'zPREFACE.globalConfig.userInfo.isSpecialIp'),
            patent_left: {},
            patent_right: {},
            routeLoading_left: true,
            routeLoading_right: true,
        };
    },
    computed: {
        ...mapGetters({
            bioHighlightEnable: 'bio/highlightEnable',
        }),
        isDualView() {
            return !this.viewParams.isSingleView;
        },
        leftPatentId() {
            return this.viewParams.leftPatentId;
        },
        rightPatentId() {
            return this.viewParams.rightPatentId;
        },
        showList() {
            try {
                return window.location.search.split('$')[0].indexOf('page=') > -1;
            } catch (error) {
                return false;
            }
        },
        hideSequenceHighlight() {
            return !this.bioHighlightEnable;
        },
        classNames() {
            return {
                [CLASS_NAME_CHEMICAL_HIGHLIGHT_SCROLL_DOM]: true,
                [CLASS_NAME_HIDE_SEQUENCE]: true,
                [CLASS_NAME_SHOW_SEQUENCE]: false,
                [CLASS_NAME_HIDE_STRUCTURE]: true,
                [CLASS_NAME_HIDE_OTHERS_STRUCTURE]: false,
            };
        },
    },
    watch: {
        leftPatentId: {
            handler(newId) {
                this.getPatentBasicInfo(newId, 'left');
                // FIXME: what this ?
                this.setIsOverFreeView(false);
            },
            immediate: true,
        },
        rightPatentId: {
            handler(newId) {
                this.getPatentBasicInfo(newId, 'right');
                // FIXME: what this ?
                this.setIsOverFreeView(false);
            },
            immediate: true,
        },
        isShowPatentList(val) {
            this.$eventHub.$emit('pageResize', val);
        },
        '$route': {
            handler: function() {
                _.set(window, 'zPREFACE.trackData.source', getRouteNameList(this.$route));
            },
            immediate: true,
        },
        isDualView: {
            handler: function(val) {
                this.setPatentListVisible(!val);
            },
            immediate: true,
        },
    },
    created() {
        installHighlightStyle(NAMESPACE_PATENT_VIEW);
        this.CLASS_NAME_APP_CONTENT = CLASS_NAME_APP_CONTENT;
        this.redirectRouter();
    },
    mounted() {
        // 绑定hotKey功能
        bindHotKeys(['patentList'], (event, handler) => {
            window.rvTrack('HotKey', { key: handler.key });
        });
        this.updateDocumentTitle();
        defer(1000);
    },
    beforeDestroy() {
        unBindHotKeys(['patentList']);
        window.onfocus = null;
    },
    methods: {
        updateDocumentTitle() {
            document.title = this.$t('patent-view.compareView.comparePatents');
        },
        alertOnClose() {
            this.alertVisible = false;
        },
        async getPatentBasicInfo(patentId, side) {
            if (!patentId || !this.isSourcePatent) return;
            this[`routeLoading_${side}`] = true;
            const patent = await this.getPatentBase(patentId);
            this[`patent_${side}`] = patent;
            this[`routeLoading_${side}`] = false;
            // 提供埋点使用的全局变量
            setGlobalRvTrackAttr(patent, side);
        },
        // 重定向路由
        redirectRouter() {
            if (this.isSourceEditText || this.isSourceEditPatent || this.isSourceCustomText) {
                this.changeCompareMode(ERouterMode.CUSTOM_ID);
            }
        },
    },
};
</script>

<style lang="scss">
@import "@patsnap-ui/design-tokens/scss/flex.scss";

.patent-view {
    overflow: hidden;
}
#header-wrapper{
    position: static; // TOC-25099 不知道为啥，玄学先改布局
}

.patent-app {
    //margin-top: 64px;
    height: calc(100vh - 65px);
    position: relative;

    .patent-app__main {
        height: 100%;
        overflow: hidden;
        .patent-app__header {
            height: $headerHeight;
            position: relative;
            z-index: 99;
            padding: 0 8px;
            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
            border-bottom: 1px solid #DFE1E6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            .patent-app__info-title {
                width: 800px;
                min-width: 0;
            }
            .patent-app__function-bar {
                flex-shrink: 0;
                font-size: 14px;
            }
        }
        .patent-app__content {
            height: calc(100% - #{$headerHeight});
            //padding-top: 10px;
            padding-right: $rightBarCollapsedWidth;
            position: relative;
            .patent-app__right-column {
                box-shadow: -1px 0 2px 0 rgba(0, 0, 0, 0.06);
                width: $rightBarCollapsedWidth;
                height: 100%;
                border-left: 1px solid #DFE1E6;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    }
    &.show-patent-list {
        .patent-app__content {
            padding-right: $rightBarWidth;
            .patent-app__right-column {
                width: $rightBarWidth;
            }
        }
    }
    &.no-patent-list {
        .patent-app__content {
            padding-right: 0;
        }
    }

    .loading-box {
        width: 75px;
        height: 50px;
        pointer-events: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
}

.kf5-content .zen-icon-attachment {
    color: #999;
    background-position: -80px -180px;
}

// fix bug PA-16803
.family-tree-full .patent-app .patent-app__main{
    margin-right: 0;
    margin-top: -130px;
}

.dual-view__container {
    position: relative;
    .view-right {
        flex: 1;
    }
    .dual-view__setting-button {
        position: absolute;
        right: 8px;
        top:11px;
    }
    &--has-setting .view-right .ps-side-view__tab {
        padding-right: 40px;
    }
}

.patent-view.compare-view {
    .patent-app__main {
        .patent-app__content {
            height: 100%;
            padding-left: 0;
        }
    }
}
</style>
